// extracted by mini-css-extract-plugin
export var card = "AuctionCard-module--card--JNxCD";
export var cardLink = "AuctionCard-module--cardLink--16Mq3";
export var cardImg = "AuctionCard-module--cardImg--4DMlG";
export var cardList = "AuctionCard-module--cardList--zMRoS";